import {
  InfoPanelTitle,
  InfoPanelDescription,
  InfoPanelLinks,
  InfoPanelFooter,
} from '@/features/jobs/details/tax-type/tax-prep-organizer/components/InfoPanel'

export function BusinessInterestExpenseLimitInfoContent() {
  return (
    <>
      <InfoPanelTitle>
        What is the business interest expense limit?
      </InfoPanelTitle>
      <InfoPanelDescription>
        <p>
          Tell us if you elected to opt out of the IRS limit on deducting
          interest for this rental.
        </p>
        <p>
          The IRS treats rental real estate as a business for this rule. Some
          rental owners can make a special election that removes the limit on
          how much interest they can deduct each year.
        </p>
        <p>Choosing this election means:</p>
        <ul>
          <li>You can deduct all of your rental&apos;s business interest.</li>
          <li>
            But you must use a slower depreciation method (called ADS) for the
            property going forward.
          </li>
        </ul>
        <p>
          Most small rental owners do not make this election unless they have a
          large amount of interest that would otherwise be limited.
        </p>
      </InfoPanelDescription>
      <InfoPanelFooter>
        <InfoPanelLinks
          links={[
            {
              label: 'IRS guidance',
              url: 'https://www.irs.gov/instructions/i8990',
            },
          ]}
        />
      </InfoPanelFooter>
    </>
  )
}
